<script>
export default {
  name: "favorite-active-svg"
}
</script>

<template>
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1002 0.702521L14.6371 5.89337L20.2182 6.71297C20.6866 6.79103 21.0768 7.10326 21.233 7.57161C21.3891 8.00093 21.272 8.5083 20.9207 8.82054L16.8617 12.8405L17.8374 18.5387C17.9155 19.0071 17.7204 19.4754 17.3301 19.7486C16.9398 20.0609 16.4324 20.0609 16.0031 19.8657L11.0074 17.1727L5.97265 19.8657C5.58237 20.0609 5.07499 20.0609 4.6847 19.7486C4.29441 19.4754 4.09927 19.0071 4.17733 18.5387L5.11402 12.8405L1.05501 8.82054C0.742779 8.5083 0.625693 8.00093 0.742779 7.57161C0.898895 7.10326 1.28918 6.79103 1.75753 6.71297L7.3777 5.89337L9.87555 0.702521C10.0707 0.273202 10.5 0 11.0074 0C11.4757 0 11.9051 0.273202 12.1002 0.702521Z" fill="#FFA500"/>
  </svg>
</template>

<style scoped>

</style>
